// Sidebar component - navigation menu on left side
// Links to different pages

/**
 * NOTES-SUMMARY-SIDEBAR
 * 
 * What this component does:
 *  - Shows navigation menu
 *  - Highlights current page
 *  - Clicking a link navigates to that page

 *NavLink vs Link:
 *  NavLink knows which page you're on and can style it differently (the active class).
 */



import React from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faUsers, faProjectDiagram, faRobot, faNewspaper } from '@fortawesome/free-solid-svg-icons';
import '../../styles/components.css';

function Sidebar({ isOpen, onClose }) {
  const handleLinkClick = () => {
    // Close mobile menu when a link is clicked
    if (onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* Mobile overlay */}
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      
      <aside className={`sidebar ${isOpen ? 'open' : ''}`}>
        <nav className="sidebar-nav">
        <ul>
          <li>
            <NavLink 
              to="/dashboard" 
              className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
              onClick={handleLinkClick}
            >
              <span className="sidebar-icon"><FontAwesomeIcon icon={faChartLine} /></span>
              Executive Dashboard
            </NavLink>
          </li>
          
          <li>
            <NavLink 
              to="/leads" 
              className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
              onClick={handleLinkClick}
            >
              <span className="sidebar-icon"><FontAwesomeIcon icon={faUsers} /></span>
              Lead Management
            </NavLink>
          </li>
          
          <li>
            <NavLink
              to="/pipeline"
              className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
              onClick={handleLinkClick}
            >
              <span className="sidebar-icon"><FontAwesomeIcon icon={faProjectDiagram} /></span>
              Pipeline
            </NavLink>
          </li>

          <li>
            <NavLink
              to="/henri"
              className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
              onClick={handleLinkClick}
            >
              <span className="sidebar-icon"><FontAwesomeIcon icon={faRobot} /></span>
              Henri Analytics
            </NavLink>
          </li>
          
          <li>
            <NavLink 
              to="/newsletter" 
              className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
              onClick={handleLinkClick}
            >
              <span className="sidebar-icon"><FontAwesomeIcon icon={faNewspaper} /></span>
              Newsletter
            </NavLink>
          </li>
        </ul>
      </nav>
    </aside>
    </>
  );
}

export default Sidebar;